<template>
  <div style="height: 100%;  display: flex; flex-direction: column;">
    <div class="logo_main" v-if="logoShow&&logoPosition=='left'">
      <!-- <el-image class="logo_img" :src="url"></el-image> -->
      <div v-if="!collapse" class="logo_text">
        <span class="logo_text_detail">{{appName}} </span>
        <span class="logo_text_detail">{{subName}} </span>
      </div>
    </div>
    <el-scrollbar  style=" height: 100%; ">


      <el-menu class="el-menu-vertical-demo" :style="{  height: scrollHeight + 'px'}" :collapse="collapse"
        @select="onMenuSelect" @open="onOpen" :unique-opened="true" :default-active="defaultActive"
        background-color="#304156" text-color="#BFCBD9" active-text-color="#1890FF">
        <side-menu-item v-for="item in menuTree" :key="item.id" :menu="item"></side-menu-item>
      </el-menu>
    </el-scrollbar>
  </div>
</template>
<script>
  import axios from '@/axios'
  import {
    mapState,
    mapGetters
  } from 'vuex'
  import SideMenuItem from './SideMenuItem'
  export default {
    data() {
      return {
        changeColor: '#e9f4ff',
        screenWidth: document.body.clientWidth,
        screenHeight: document.documentElement.clientHeight,
        scrollHeight: document.body.clientHeight - 60,
        // url: require('../../../assets/img/sd.png'),
      }
    },
    components: {
      SideMenuItem
    },
    methods: {
      onMenuSelect: function(index, indexPath) {
        //console.log("onMenuSelect:"+index)
        this.$router.push(index)
      },
      onOpen: function(index, indexPath) {
        if (index.length == 3) {
          var url = 'framework/SysMenu/queryByMenuCode.do'
          var param = {
            code: index,
          }
          axios.get(url, param).then(response => {
            this.$store.commit('setSecName', '-' + response.data.data.menuName)
          });
        }
      }
    },
    computed: {
      // collapse() {
      //   return this.$store.getters.collapse
      // },
      ...mapGetters(['collapse', 'logoShow', 'logoPosition']),
      ...mapState({
        themeColor: state => state.app.themeColor,
        menuTree: state => state.menu.menuTree,
        defaultActive: state => state.tabsbar.activePage.path,
        appName: state => state.app.appName,
        subName: state => state.app.subName,
        secName: state => state.app.secName,
      })
    },
    mounted() {
      console.log(this.logoPosition)
      if (this.logoPosition == 'left') {
        this.scrollHeight = this.screenHeight - 60
      }else {
         this.scrollHeight = this.screenHeight
      }
    }
  }
</script>

<style>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    /* min-height: 600px; */

  }



  .logo_main {
    height: 60px;
    margin-right: 1px;
    background-color: #304156;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    transition: .5s;
    overflow: hidden;
  }

  .logo_img {
    width: 40px;
    height: 40px;
  }

  .logo_text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .logo_text_detail {
    font-size: 16px;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/view/framework/home/SideMenuBar.vue